<a class="notification-link" (click)="downloadFile()">{{
    'Query::ClickHereToDownloadCategoryReport' | abpLocalization
  }}</a>